export function portalStyles() {
  return `
    <style id="operator-portal-styles">
      .operator-portal {
        min-height: calc(100vh - 96px);
        padding: 104px 24px 48px;
        background:
          radial-gradient(circle at top right, rgba(244,91,105,0.14), transparent 30%),
          radial-gradient(circle at left center, rgba(120,123,255,0.1), transparent 28%),
          linear-gradient(180deg, #f7f1e7 0%, #f3ede2 100%);
      }
      .op-shell {
        width: min(1180px, 100%);
        margin: 0 auto;
        display: grid;
        gap: 20px;
      }
      .op-header, .op-card, .op-list-card {
        background: rgba(255,255,255,0.86);
        border: 1px solid rgba(55,38,20,0.08);
        border-radius: 24px;
        box-shadow: 0 24px 80px rgba(55,38,20,0.08);
        backdrop-filter: blur(14px);
      }
      .op-header {
        padding: 24px 28px;
        display: grid;
        gap: 18px;
      }
      .op-eyebrow {
        font-size: 11px;
        letter-spacing: 0.18em;
        text-transform: uppercase;
        color: rgba(55,38,20,0.58);
      }
      .op-header-main {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 18px;
      }
      .op-title {
        font-family: 'Fraunces', serif;
        font-size: clamp(2rem, 4vw, 3.3rem);
        line-height: 1.02;
        color: #2c2015;
        margin: 0;
      }
      .op-subtitle {
        max-width: 760px;
        font-size: 15px;
        line-height: 1.6;
        color: rgba(55,38,20,0.72);
      }
      .op-workspace-switch {
        display: flex;
        align-items: center;
        gap: 12px;
        flex-wrap: wrap;
      }
      .op-workspace-switch select {
        appearance: none;
        border: 1px solid rgba(55,38,20,0.12);
        border-radius: 999px;
        padding: 10px 16px;
        background: #fff;
        font: inherit;
        color: #2c2015;
      }
      .op-metrics {
        display: grid;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        gap: 14px;
      }
      .op-card {
        padding: 18px 18px 20px;
      }
      .op-card-label {
        font-size: 11px;
        letter-spacing: 0.14em;
        text-transform: uppercase;
        color: rgba(55,38,20,0.56);
        margin-bottom: 12px;
      }
      .op-card-value {
        font-family: 'Fraunces', serif;
        font-size: 2rem;
        color: #20160f;
      }
      .op-card-note {
        font-size: 13px;
        color: rgba(55,38,20,0.68);
        margin-top: 8px;
      }
      .op-hero-card {
        padding: 28px 30px;
        display: grid;
        gap: 16px;
      }
      .op-guidance-list {
        margin: 0;
        padding-left: 18px;
        color: rgba(55,38,20,0.72);
        line-height: 1.7;
      }
      .op-join-form {
        display: flex;
        gap: 10px;
        flex-wrap: wrap;
        margin-top: 8px;
      }
      .op-input {
        flex: 1 1 320px;
        border: 1px solid rgba(55,38,20,0.12);
        border-radius: 16px;
        padding: 12px 14px;
        background: #fff;
        color: #241911;
        font: inherit;
      }
      .op-inline-note {
        font-size: 13px;
        color: rgba(55,38,20,0.62);
      }
      .op-toolbar {
        display: flex;
        align-items: center;
        gap: 10px;
        flex-wrap: wrap;
      }
      .op-alert {
        border-radius: 16px;
        padding: 14px 16px;
        background: rgba(244,91,105,0.08);
        border: 1px solid rgba(244,91,105,0.14);
        color: #9a3240;
      }
      .op-success {
        border-radius: 16px;
        padding: 14px 16px;
        background: rgba(44,163,97,0.08);
        border: 1px solid rgba(44,163,97,0.14);
        color: #1d7544;
      }
      .op-invite-panel {
        display: grid;
        gap: 14px;
        padding: 18px 20px;
        border-radius: 18px;
        background: rgba(255,255,255,0.72);
        border: 1px solid rgba(55,38,20,0.08);
      }
      .op-invite-panel.hidden {
        display: none;
      }
      .op-invite-grid {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 10px;
      }
      .op-field {
        display: grid;
        gap: 6px;
      }
      .op-field label {
        font-size: 11px;
        letter-spacing: 0.12em;
        text-transform: uppercase;
        color: rgba(55,38,20,0.56);
      }
      .op-field select,
      .op-field input {
        border: 1px solid rgba(55,38,20,0.12);
        border-radius: 14px;
        padding: 10px 12px;
        background: #fff;
        color: #241911;
        font: inherit;
      }
      .op-invite-result {
        display: grid;
        gap: 10px;
      }
      .op-copy-row {
        display: flex;
        gap: 8px;
        align-items: center;
        flex-wrap: wrap;
      }
      .op-copy-value {
        flex: 1 1 320px;
        border-radius: 14px;
        padding: 10px 12px;
        background: rgba(44,32,21,0.06);
        color: #241911;
        font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, monospace;
        font-size: 12px;
        overflow-wrap: anywhere;
      }
      .op-miga-form {
        display: grid;
        gap: 12px;
      }
      .op-miga-form textarea {
        min-height: 108px;
        resize: vertical;
      }
      .op-miga-output {
        border-radius: 18px;
        padding: 14px 16px;
        background: rgba(44,32,21,0.04);
        border: 1px solid rgba(55,38,20,0.08);
        color: rgba(55,38,20,0.76);
        line-height: 1.6;
        white-space: pre-wrap;
      }
      .op-miga-meta {
        font-size: 12px;
        color: rgba(55,38,20,0.58);
      }
      .op-miga-state {
        display: grid;
        gap: 10px;
      }
      .op-miga-answer {
        border-radius: 18px;
        padding: 14px 16px;
        background: rgba(44,32,21,0.04);
        border: 1px solid rgba(55,38,20,0.08);
        color: rgba(55,38,20,0.76);
        line-height: 1.6;
        white-space: pre-wrap;
      }
      .op-miga-pills {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
      }
      .op-miga-pill {
        display: inline-flex;
        align-items: center;
        border-radius: 999px;
        padding: 4px 10px;
        font-size: 10px;
        font-weight: 700;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        background: rgba(44,32,21,0.06);
        color: rgba(44,32,21,0.78);
      }
      .op-miga-pill.grounded,
      .op-miga-pill.live {
        background: rgba(44,163,97,0.12);
        color: #1d7544;
      }
      .op-miga-pill.partial,
      .op-miga-pill.cached,
      .op-miga-pill.mixed,
      .op-miga-pill.stale_fallback {
        background: rgba(240,180,41,0.14);
        color: #9c6611;
      }
      .op-miga-pill.blocked,
      .op-miga-pill.failed,
      .op-miga-pill.unsupported {
        background: rgba(244,91,105,0.12);
        color: #9a3240;
      }
      .op-miga-note {
        border-radius: 14px;
        padding: 12px 14px;
        background: rgba(44,32,21,0.04);
        border: 1px solid rgba(55,38,20,0.08);
        font-size: 13px;
        color: rgba(55,38,20,0.72);
        line-height: 1.55;
      }
      .op-miga-note strong {
        color: #2c2015;
      }
      .op-miga-note ul {
        margin: 8px 0 0 18px;
        padding: 0;
      }
      .op-miga-note li + li {
        margin-top: 4px;
      }
      .op-miga-evidence {
        display: grid;
        gap: 8px;
      }
      .op-miga-evidence-item {
        border-radius: 14px;
        padding: 12px 14px;
        background: rgba(255,255,255,0.74);
        border: 1px solid rgba(55,38,20,0.08);
      }
      .op-miga-evidence-title {
        font-size: 10px;
        font-weight: 700;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        color: rgba(55,38,20,0.56);
        margin-bottom: 4px;
      }
      .op-miga-evidence-meta {
        font-size: 13px;
        color: rgba(55,38,20,0.72);
      }
      .op-grid {
        display: grid;
        grid-template-columns: 1.4fr 1fr;
        gap: 20px;
      }
      .op-column {
        display: grid;
        gap: 20px;
      }
      .op-list-card {
        padding: 20px 22px;
      }
      .op-list-head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        margin-bottom: 16px;
      }
      .op-list-title {
        font-family: 'Fraunces', serif;
        font-size: 1.28rem;
        color: #2c2015;
        margin: 0;
      }
      .op-list-subtitle {
        font-size: 12px;
        color: rgba(55,38,20,0.56);
      }
      .op-empty {
        padding: 18px 0 4px;
        color: rgba(55,38,20,0.58);
        line-height: 1.6;
      }
      .op-empty--warm {
        position: relative;
        display: grid;
        grid-template-columns: 56px 1fr;
        gap: 14px;
        align-items: center;
        padding: 14px 16px;
        margin-top: 6px;
        border-radius: 16px;
        background: linear-gradient(180deg, rgba(255,255,255,0.78) 0%, rgba(255, 245, 230, 0.5) 100%);
        border: 1px solid rgba(55,38,20,0.08);
        box-shadow: inset 0 1px 0 rgba(255,255,255,0.8);
        overflow: hidden;
      }
      .op-empty--warm.op-empty--info {
        background: linear-gradient(180deg, rgba(120,123,255,0.10) 0%, rgba(255,255,255,0.74) 100%);
        border-color: rgba(120,123,255,0.18);
      }
      .op-empty--warm.op-empty--success {
        background: linear-gradient(180deg, rgba(80,176,128,0.10) 0%, rgba(255,255,255,0.74) 100%);
        border-color: rgba(80,176,128,0.18);
      }
      .op-empty-stage {
        position: relative;
        width: 56px;
        height: 56px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .op-empty-halo {
        position: absolute;
        inset: -4px;
        border-radius: 50%;
        background: radial-gradient(closest-side, rgba(120,123,255,0.22) 0%, transparent 72%);
        animation: op-empty-breathe 5.4s ease-in-out infinite;
      }
      .op-empty--success .op-empty-halo {
        background: radial-gradient(closest-side, rgba(80,176,128,0.22) 0%, transparent 72%);
      }
      .op-empty-miga {
        position: relative;
        z-index: 2;
        filter: drop-shadow(0 4px 14px rgba(55,38,20,0.18));
        animation: op-empty-miga-tilt 6.4s ease-in-out infinite;
      }
      .op-empty-trail {
        position: absolute;
        bottom: 8px;
        left: 4px;
        width: 4px;
        height: 3px;
        border-radius: 50%;
        background: rgba(55,38,20,0.32);
        opacity: 0;
      }
      .op-empty-trail--a { animation: op-empty-march 5.6s linear infinite; animation-delay: 0s; }
      .op-empty-trail--b { animation: op-empty-march 5.6s linear infinite; animation-delay: 1.4s; }
      @keyframes op-empty-march {
        0%   { transform: translate(0, 0)   scale(0.5); opacity: 0; }
        15%  { opacity: 0.85; }
        100% { transform: translate(48px, -2px) scale(0.7); opacity: 0; }
      }
      @keyframes op-empty-breathe {
        0%, 100% { transform: scale(1);    opacity: 0.85; }
        50%      { transform: scale(1.04); opacity: 1; }
      }
      @keyframes op-empty-miga-tilt {
        0%, 100% { transform: rotate(-2deg); }
        50%      { transform: rotate(2deg); }
      }
      .op-empty-body {
        padding: 0;
      }
      .op-empty-headline {
        font-family: 'Fraunces', serif;
        font-size: 15px;
        color: #2c2015;
        margin-bottom: 2px;
      }
      .op-empty-text {
        font-size: 13px;
        line-height: 1.55;
        color: rgba(55,38,20,0.7);
      }
      @media (prefers-reduced-motion: reduce) {
        .op-empty-halo,
        .op-empty-miga,
        .op-empty-trail--a,
        .op-empty-trail--b { animation: none !important; }
        .op-empty-trail--a,
        .op-empty-trail--b { display: none; }
      }
      .op-item {
        padding: 14px 0;
        border-top: 1px solid rgba(55,38,20,0.08);
      }
      .op-item:first-of-type {
        border-top: none;
        padding-top: 0;
      }
      .op-item-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
      }
      .op-item-title {
        font-size: 14px;
        font-weight: 600;
        color: #241911;
      }
      .op-item-meta {
        margin-top: 6px;
        font-size: 12px;
        line-height: 1.55;
        color: rgba(55,38,20,0.68);
      }
      .op-badge {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        border-radius: 999px;
        padding: 4px 10px;
        font-size: 11px;
        font-weight: 700;
        letter-spacing: 0.08em;
        text-transform: uppercase;
      }
      .op-badge.pending { background: rgba(240,180,41,0.16); color: #8a5d05; }
      .op-badge.approved { background: rgba(44,163,97,0.14); color: #1d7544; }
      .op-badge.rejected, .op-badge.failed { background: rgba(244,91,105,0.14); color: #a22f3e; }
      .op-actions {
        display: flex;
        gap: 8px;
        margin-top: 12px;
        flex-wrap: wrap;
      }
      .op-btn {
        border: 1px solid rgba(55,38,20,0.12);
        border-radius: 999px;
        padding: 8px 12px;
        background: #fff;
        color: #241911;
        font: inherit;
        cursor: pointer;
      }
      .op-btn.primary {
        background: #f45b69;
        border-color: #f45b69;
        color: #fff;
      }
      .op-btn:disabled {
        cursor: wait;
        opacity: 0.65;
      }
      .op-health {
        display: flex;
        align-items: baseline;
        gap: 10px;
      }
      .op-health-score {
        font-family: 'Fraunces', serif;
        font-size: 2.6rem;
        color: #2c2015;
      }
      .op-health-delta {
        font-size: 12px;
        color: rgba(55,38,20,0.56);
      }
      @media (max-width: 920px) {
        .op-metrics, .op-grid {
          grid-template-columns: 1fr;
        }
        .op-invite-grid {
          grid-template-columns: 1fr;
        }
        .op-header-main {
          flex-direction: column;
        }
      }
    </style>
  `
}
